import React from "react";
import { X, EyeOff } from "lucide-react";

export const VideoModal = ({ title, url, onClose, onHide }) => (
  <div className="fixed inset-0 z-[90] bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid="video-modal">
    <div className="bg-white rounded-2xl w-full max-w-[640px] overflow-hidden" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
        <p className="font-semibold text-[#16243b] text-sm">{title}</p>
        <button onClick={onClose} data-testid="video-modal-close"><X size={18} className="text-[#5a6b80]" /></button>
      </div>
      <video src={`${process.env.REACT_APP_BACKEND_URL}${url}`} controls autoPlay playsInline className="w-full bg-black max-h-[70vh]" data-testid="video-modal-player" />
      {onHide && (
        <div className="flex items-center justify-between px-5 py-3 border-t border-gray-100">
          <p className="text-xs text-[#8a97a8]">Inappropriate? Hiding removes it from the voucher page, reaction link and here.</p>
          <button onClick={onHide} data-testid="video-modal-hide" className="inline-flex items-center gap-1.5 rounded-full border border-red-200 text-red-600 px-3 py-1.5 text-xs font-medium hover:bg-red-50 shrink-0 ml-3"><EyeOff size={13} /> Hide video</button>
        </div>
      )}
    </div>
  </div>
);
